module.exports = __webpack_public_path__ + "img/slide_4.6177751e.jpg";